import React, { Component } from 'react';
import {
  Form,
  Label,
  Input,
  Button,
  Dropdown,
  SelectTags
} from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Cor extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Cor">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Cor__Form"
        >
          <h1>{translate('fiche.cor.title')}</h1>

          <Label text={translate('fiche.cor.volume')} />
          <Dropdown
            name="volume"
            rules={['required']}
            defaultValue={data.volume}
            data={[
              { value: '-', label: translate('fiche.normal') },
              { value: 'deviant', label: translate('fiche.deviant') }
            ]}
          />

          <Label text={translate('fiche.cor.murmurs')} />
          <SelectTags
            name="murmurs"
            tags={translate('fiche.cor.murmurs_choices')}
            defaultValue={data.murmurs}
          />

          <h2>{translate('fiche.cor.blood_pressure')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text="Systole" />
              <Input
                name="systole"
                rules={['required']}
                defaultValue={data.systole}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text="Diastole" />
              <Input
                name="diastole"
                rules={['required']}
                defaultValue={data.diastole}
              />
            </div>
          </div>

          <h2>ECG</h2>

          <Label text={translate('fiche.cor.ecg_date')} />
          <Input
            name="ecg_date"
            placeholder="DD/MM/YYYY"
            defaultValue={data.ecg_date}
            rules={['date', 'required']}
          />

          <Label text={translate('fiche.cor.ecg_rest')} />
          <Input
            name="ecg_rest"
            defaultValue={data.ecg_rest}
            rules={['required']}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Cor);
